import { z } from 'zod';

/** A full civil year, January–December or Tishrei–Elul (including both Adars). */
export const CalendarOptions = z.object({
  system: z.enum(['gregorian', 'hebrew']).default('gregorian'),
  year: z.number().int(),
  dualDates: z.boolean().default(true),
  jewishHolidays: z.boolean().default(true),
  israeliHolidays: z.boolean().default(true),
  region: z.enum(['israel', 'diaspora']).default('israel'),
  weekStart: z.union([z.literal(0), z.literal(1)]).default(0),
}).superRefine((value, ctx) => {
  const [min, max]: [number, number] = value.system === 'hebrew' ? [5660, 5900] : [1900, 2100];
  if (value.year < min || value.year > max) {
    ctx.addIssue({ code: 'custom', path: ['year'], message: `Year must be between ${min} and ${max}` });
  }
});
export type CalendarOptions = z.infer<typeof CalendarOptions>;
